import { render, staticRenderFns } from "./MailDashboard.vue?vue&type=template&id=a6c15f30&scoped=true&"
import script from "./MailDashboard.vue?vue&type=script&lang=js&"
export * from "./MailDashboard.vue?vue&type=script&lang=js&"
import style0 from "./MailDashboard.vue?vue&type=style&index=0&id=a6c15f30&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6c15f30",
  null
  
)

export default component.exports